import React, { useState } from "react";
import _ from "lodash";
import ContentWrapper from "../Wrapper";
import { CustomSubHeader } from "../../components/subheader";
import { ContentWithCardLoading } from "../../components/loading";

import "./index.scss";
import CopyPasteEditor from "../../components/copy-paste-editor/copy-paste-editor";
import { Button, Form } from "react-bootstrap";
import SimpleDropdown from "../../components/dropdowns/simple-dropdown";
import { useDispatch } from "react-redux";
import { verifyNumberRequest } from "./store/actions/index.action";

const regionOptions = [
    { value: "AP", label: "Andhra Pradesh (AP)" },
    { value: "AS", label: "Assam (AS)" },
    { value: "BR", label: "Bihar (BR)" },
    { value: "CH", label: "Chennai (CH)" },
    { value: "DL", label: "Delhi (DL)" },
    { value: "GJ", label: "Gujarat (GJ)" },
    { value: "HR", label: "Haryana (HR)" },
    { value: "HP", label: "Himachal Pradesh (HP)" },
    { value: "JK", label: "Jammu and Kashmir (JK)" },
    { value: "KA", label: "Karnataka (KA)" },
    { value: "KL", label: "Kerala (KL)" },
    { value: "KO", label: "Kolkata (KO)" },
    { value: "UW", label: "Uttar Pradesh (West) (UW)" },
    { value: "MP", label: "Madhya Pradesh (MP)" },
    { value: "MH", label: "Maharashtra & Goa (MH)" },
    { value: "MU", label: "Mumbai (MU)" },
    { value: "NE", label: "North East (NE)" },
    { value: "OR", label: "Orissa (OR)" },
    { value: "PB", label: "Punjab (PB)" },
    { value: "RJ", label: "Rajasthan (RJ)" },
    { value: "TN", label: "Tamil Nadu (TN)" },
    { value: "UE", label: "Uttar Pradesh (East) (UE)" },
    { value: "WB", label: "West Bengal (WB)" }

]
// const regionOptions = [
//     { value: "AP", label: "Andhra Pradesh (AP)" },
//     { value: "AS", label: "Assam (AS)" },
//     { value: "BR", label: "Bihar & Jharkhand (BR)" },
//     { value: "CH", label: "Chennai (CH)" },
//     { value: "DL", label: "Delhi (DL)" },
//     { value: "GJ", label: "Gujarat (GJ)" },
//     { value: "HP", label: "Himachal Pradesh (HP)" },
//     { value: "HR", label: "Haryana (HR)" },
//     { value: "JK", label: "Jammu and Kashmir (JK)" },
//     { value: "KL", label: "Kerala & Lakshadweep (KL)" },
//     { value: "KO", label: "Kolkata (KO)" },
//     { value: "KA", label: "Karnataka (KA)" },
//     { value: "MH", label: "Maharashtra & Goa (MH)" },
//     { value: "MP", label: "Madhya Pradesh & Chhattisgarh (MP)" },
//     { value: "MU", label: "Mumbai (MU)" },
//     { value: "NE", label: "North East (NE)" },
//     { value: "OR", label: "Odisha (OR)" },
//     { value: "PB", label: "Punjab (PB)" },
//     { value: "RJ", label: "Rajasthan (RJ)" },
//     { value: "TN", label: "Tamil Nadu (TN)" },
//     { value: "UE", label: "UP (East) (UE)" },
//     { value: "UW", label: "UP (West) (UW)" },
//     { value: "WB", label: "West Bengal (WB)" }
// ]

export default function NumberVerify() {
    const [loading, setLoading] = useState(false);
    const [copyPastDefaultValue, setCopyPasteDefaultValue] = useState("11");
    const [copyPastedData, setCopyPastedData] = useState("");
    const [audienceCount, setAudienceCount] = useState(0);
    const [region, setRegion] = useState({ value: "MH", label: "Maharashtra & Goa (MH)" });

    // result
    const [resultCopyPastDefaultValue, setResultCopyPasteDefaultValue] = useState("11");
    const [resultCopyPastedData, setResultCopyPastedData] = useState("");
    const [resultAudienceCount, setResultAudienceCount] = useState(0);

    const dispatch = useDispatch();

    const clearFunction = () => {
        setCopyPastedData("");
        setAudienceCount(0);
        setCopyPasteDefaultValue("");
    };

    const uniqueFunction = () => {
        const copyPastedDataArray = copyPastedData.split(/,|\s|\n/);
        const uniqueValues = _.filter(_.uniq(_.map(copyPastedDataArray, _.trim)), o => o);
        const valueToString = uniqueValues.join("\n");
        setCopyPastedData(valueToString);
        setCopyPasteDefaultValue(valueToString);
        setAudienceCount(uniqueValues.length);
    };

    const handleVerifyNumberClick = () => {
        setLoading(true);
        const copyPastedDataArray = copyPastedData.split(/,|\s|\n/);
        const uniqueValues = _.filter(_.uniq(_.map(copyPastedDataArray, _.trim)), o => o);
        const valueToString = uniqueValues.join(",");
        const payload = {
            "numbers": valueToString,
            "operator": "All",
            "region": region.value
        }
        setResultCopyPastedData("")
        setResultCopyPasteDefaultValue("")
        setResultAudienceCount(0)
        dispatch(verifyNumberRequest(payload, (data) => {
            setLoading(false)
            if (data.status) {
                const resultArray = data.data
                const resultToString = resultArray.join("\n");
                setResultCopyPastedData(resultToString);
                setResultCopyPasteDefaultValue(resultToString);
                setResultAudienceCount(resultArray.length);
            }
            else {
                console.log("error", data)
            }
        }))
    }

    return (
        <ContentWrapper subHeader={<CustomSubHeader />}>
            <div className="verify-number-wrapper">
                <div className="verify-number-internal-wrapper">
                    <div className={`section-1 card card-custom p-8 `}>
                        <Form.Label className="fw-bold">Number</Form.Label>
                        <Form.Group>
                            <CopyPasteEditor
                                copyPastDefaultValue={copyPastDefaultValue}
                                copyPastedData={copyPastedData}
                                copyPastedCount={audienceCount}
                                clearFunction={clearFunction}
                                uniqueFunction={uniqueFunction}
                                setCopyPastedData={setCopyPastedData}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="fw-bold">Type</Form.Label>
                            <SimpleDropdown showSearch={true} value={region} label={"Type"} options={regionOptions} handleSelect={setRegion} />
                        </Form.Group>
                        <Form.Group className="d-flex justify-content-end">
                            <Button size="sm" onClick={handleVerifyNumberClick}>verify</Button>
                        </Form.Group>
                    </div>
                    <div className={`section-2 card card-custom p-8`}>
                        <Form.Label className="fw-bold">Result</Form.Label>
                        {loading && <ContentWithCardLoading />}
                        {!loading && <Form.Group>
                            <CopyPasteEditor
                                copyPastDefaultValue={resultCopyPastDefaultValue}
                                copyPastedData={resultCopyPastedData}
                                copyPastedCount={resultAudienceCount}
                                clearFunction={() => { }}
                                uniqueFunction={() => { }}
                                setCopyPastedData={setResultCopyPastedData}
                            />
                        </Form.Group>}
                    </div>
                </div>
            </div>
        </ContentWrapper>
    );
}